import React from 'react';
import { Link } from 'react-router-dom';
import Btn from '../../shims/commonUiBtn';

export default function EmptyState({ hasActiveFilters = false }) {
  return (
    <div className="text-center py-4">
      <p className="text-muted mb-3">
        {hasActiveFilters
          ? 'No tickets match your search. Try adjusting your filters.'
          : 'No tickets yet. Create your first ticket.'}
      </p>
      {!hasActiveFilters && (
        <Btn attrBtn={{ tag: Link, to: '/ticketing/create', color: 'primary' }}>
          Create Ticket
        </Btn>
      )}
    </div>
  );
}
